// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-1d5907b2]:disabled{pointer-events:all}", "",{"version":3,"sources":["webpack://./bundles/Factory/CustomAdminBundle/public/vue/components/PageControls.vue"],"names":[],"mappings":"AACI,+BACI,kBAAR","sourcesContent":["\n    .btn:disabled\n        pointer-events: all\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
